import styled from "styled-components";
import { TextArea as TextAreaFragment } from "@sonder/ui/source/styled/primitives/TextArea";
import { colors, typeface } from "@sonder/ui/source/styled/theme";

export interface TextAreaProps {
  error?: boolean;
}
export const TextArea = styled(TextAreaFragment)<TextAreaProps>`
  background: ${colors.white};
  color: ${props => (props.error ? colors.redD : colors.gray1)};
  font-family: ${typeface.primary};
  font-size: 1rem;

  &::placeholder {
    color: ${props => (props.error ? colors.redLight : colors.gray6)};
  }

  &:disabled {
    color: ${colors.grayA};
    &::placeholder {
      color: ${colors.grayA};
    }
  }
`;
